module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_chugoku-shikoku_pc_85a0fe91b40960ea8a1857b286c51637.png";